export default __webpack_public_path__ + "static/media/product-image-17.d960ca75.jpg";